import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { FONT_TYPES, mediaMixin, Text, token, typographyMixin } from '@zillow/constellation';

export const StyledNavItem = styled.div<{ isInMenuPopper?: boolean }>`
  ${({ isInMenuPopper = false }) =>
    isInMenuPopper && {
      width: '100%',
      display: 'flex',
    }};

  ${mediaMixin(
    'md',
    css`
      width: 131px;
    `,
  )};
`;

export const StyledLink = styled(Link)<{ isActive?: boolean }>`
  color: ${({ isActive }) => (isActive ? token('colors.blue400') : token('colors.textMedium'))};
`;

export const StyledText = styled(Text)<{ isActive?: boolean }>`
  color: inherit;

  /* handle specific range to better match design */
  @media (min-width: 390px) and (max-width: 480px) {
    ${typographyMixin({ fontType: FONT_TYPES.h0 })}

    font-size: ${({ isActive }) => (isActive ? token('fontSizes.bodySmallHeading') : token('fontSizes.bodySmall'))}px;
  }
`;
